import { CountryCode } from "@oysterhr/common"
import { GlobalPayrollPayrollCycleTypeEnum } from "@oysterhr/schema"

type FrequencyOptionType = {
  label: CountryCode
  value: GlobalPayrollPayrollCycleTypeEnum[]
}

const PAYROLL_CYCLE_FREQUENCIES_OPTIONS = [
  {
    label: "US",
    value: [
      GlobalPayrollPayrollCycleTypeEnum.BiWeekly,
      GlobalPayrollPayrollCycleTypeEnum.SemiMonthly,
    ],
  },
  { label: "CA", value: [GlobalPayrollPayrollCycleTypeEnum.SemiMonthly] },
  { label: "MX", value: [GlobalPayrollPayrollCycleTypeEnum.SemiMonthly] },
] as unknown as FrequencyOptionType[]

export const getCountryPayrollCycleFrequencyOptions = (code: string) => {
  const countryFrequencyOptions = PAYROLL_CYCLE_FREQUENCIES_OPTIONS.find(a => a.label === code)
  return countryFrequencyOptions
    ? countryFrequencyOptions.value
    : [GlobalPayrollPayrollCycleTypeEnum.Monthly]
}
